import { jsxs as $, jsx as C } from "react/jsx-runtime";
import { c as B } from "./index.CWkFp9WS.js";
import z, { useState as b, useId as E, useRef as J, useEffect as i } from "react";
import { O as K } from "./ODSColumn.B8Qu83P2.js";
import { O as T } from "./ODSRow.Du_e7gfN.js";
import { O as M } from "./ODSSupportMessage.DxN3bpZC.js";
import { O as Q } from "./ODSText.D6mgyggF.js";
import { O as U } from "./ODSCheckboxIcon.BUNGF0py.js";
import '../assets/ODSCheckbox.css';function V(s, n) {
  if (!(s && n))
    return s ? "true" : "false";
}
const re = ({
  className: s,
  size: n = "large",
  mode: r = "standard",
  supportMessage: f,
  disabled: t = !1,
  label: S,
  defaultChecked: x,
  onCheckedChange: k,
  checked: c,
  ariaLabelCheckbox: j,
  indeterminate: D,
  readonly: I = !1,
  id: y,
  containerProps: _,
  supportMessageProps: w,
  inputProps: e,
  ...A
}) => {
  const [u, g] = b(
    x ?? !1
  ), [G, F] = b(!1), [h, R] = b(!1), v = E(), H = E(), L = y ?? (e == null ? void 0 : e.id) ?? H, o = c !== void 0, d = J(null), q = z.useRef(null), m = {};
  o ? (m.checked = c, m.onChange = k) : m.defaultChecked = x, i(() => {
    R(!!D);
  }, [D]), i(() => {
    d.current && h && (d.current.indeterminate = !0);
  }, [h]), i(() => {
    o && g(c);
  }, [c, o]), i(() => {
    const a = d.current, l = (O) => {
      o || g(O.target.checked);
    };
    return a == null || a.addEventListener("change", l), () => {
      a == null || a.removeEventListener("change", l);
    };
  }, [o]);
  const N = (a) => {
    var l, O;
    if (a.type === "blur") {
      (l = e == null ? void 0 : e.onBlur) == null || l.call(e, a), F(!1);
      return;
    }
    (O = e == null ? void 0 : e.onFocus) == null || O.call(e, a), F(!0);
  };
  return /* @__PURE__ */ $(
    T,
    {
      "data-focus": G,
      className: B(
        "ODSCheckbox",
        `ODSCheckbox--size-${n}`,
        `ODSCheckbox--mode-${r}`,
        t && `ODSCheckbox--disabled-${t}`,
        I && !t && "ODSCheckbox--readonly",
        u && "ODSCheckbox-Checked",
        h && "ODSCheckbox-Indeterminate",
        s
      ),
      ..._,
      ref: q,
      children: [
        /* @__PURE__ */ C(T, { className: "ODSCheckbox-Input-Container", children: /* @__PURE__ */ C(
          U,
          {
            size: n,
            checked: c,
            defaultChecked: x,
            indeterminate: D,
            disabled: t,
            error: r === "error",
            readonly: I,
            ref: d,
            onBlur: N,
            onFocus: N,
            onChange: k,
            inputProps: {
              id: L,
              "aria-label": j,
              "aria-checked": V(
                u,
                h
              ),
              "aria-invalid": r === "error",
              "aria-describedby": r !== "standard" && f ? v : void 0,
              ...e
            },
            ...m,
            ...A
          }
        ) }),
        S || r !== "standard" && f ? /* @__PURE__ */ $(
          K,
          {
            as: "span",
            className: B(
              "ODSCheckbox-LabelMessage",
              `ODSCheckbox-LabelMessage--size-${n}`
            ),
            children: [
              S ? /* @__PURE__ */ C(Q, { as: "label", htmlFor: L, className: "ODSCheckbox-Label", children: S }) : null,
              r !== "standard" && f && /* @__PURE__ */ C(
                M,
                {
                  ...w,
                  mode: r === "error" ? "error" : "informative",
                  helperText: f,
                  disabled: t,
                  id: v
                }
              )
            ]
          }
        ) : null
      ]
    }
  );
};
export {
  re as O
};
//# sourceMappingURL=ODSCheckbox.bwFt5LUJ.js.map
